import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { AppConfig } from '../app.config';
import { User } from '../models/user';
import { BaseService } from './BaseService';

@Injectable()
export class UserService extends BaseService {

    constructor(private http: Http, private config: AppConfig) {

    super();
     }

    getAll() {
        return this.http.get(this.config.apiUrl + '/users/', this.jwt(true))
          .map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get(this.config.apiUrl + '/users/' + _id, this.jwt(true))
          .map((response: Response) => response.json());
    }

    create(user) {
        return this.http.post(this.config.apiUrl + '/users/', user, this.jwt(true));
    }

    update(user) {
        return this.http.put(this.config.apiUrl + '/users/' + user.id, user, this.jwt(true));
    }

    delete(id: string) {
        return this.http.delete(this.config.apiUrl + '/users/' +id, this.jwt(true));
    }

}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts